<template>
  <el-dialog custom-class="see_price" :modal="false" top="25vh" :visible.sync="dialogVisible" :before-close="handleClose">
    <div class="form" v-if="isRequired">
      <p class="tips">此操作需要进行身份验证，请按提示操作</p>
      <el-input placeholder="请输入登录密码" v-model="password" clearable show-password></el-input>
      <el-button type="primary" @click="login">确定</el-button>
    </div>
    <ul class="table" v-else>
      <li>采购价：<span class="price">￥{{tradePrice | priceValue}}</span></li>
      <li>建议零售价：<span class="price">￥{{suggestPrice | priceValue}}</span></li>
    </ul>
  </el-dialog>
</template>

<script>
import {
  GetGoodsMixTradePrice,
  GetGoodsMixTradePricePwd,
} from "@/pages/page1/api/modules/goods";
import onlyMessage from '@/pages/publicUtils/resetMessage.js'
export default {
  data() {
    return {
      mixSerNo: undefined,
      dialogVisible: false,
      isRequired: true,
      password: "",
      tradePrice: 0, //采购价
      suggestPrice: 0, //建议零售价
      interv: undefined,
    };
  },
  methods: {
    seePrice(mixSerNo) {
      this.mixSerNo = mixSerNo;
      // 重置
      this.tradePrice = 0;
      this.suggestPrice = 0;
      this.password = "";

      this.getGoodsMixTradePrice(mixSerNo);
    },
    login() {
      if (!this.password) {
        onlyMessage.error("请输入密码");
        return;
      }
      this.getGoodsMixTradePricePwd(this.mixSerNo);
    },
    getGoodsMixTradePrice(mixSerNo) {
      let params = {
        mixSerNo,
        clientType: 0, //pc=0 小程序=1 h5=5 pc_shop=6
      };
      GetGoodsMixTradePrice(params).then((res) => {
        // console.log("查看采购价", res);
        this.isRequired = res.data[0].isPass ? false : true;
        this.tradePrice = res.data[0].priceObj.tradePrice;
        this.suggestPrice = res.data[0].priceObj.suggestPrice;
        this.dialogVisible = true;
        if (!this.isRequired) this.setInterV();
      });
    },
    getGoodsMixTradePricePwd(mixSerNo) {
      let params = {
        mixSerNo,
        userPwd: this.password,
        clientType: 0, //pc=0 小程序=1 h5=5 pc_shop=6
      };
      GetGoodsMixTradePricePwd(params).then((res) => {
        // console.log("密码查看采购价", res);
        this.isRequired = false;
        this.tradePrice = res.data[0].tradePrice;
        this.suggestPrice = res.data[0].suggestPrice;
        this.setInterV();
      });
    },
    setInterV() {
      let time = 6;
      this.interv = setInterval(() => {
        // console.log(time);
        time--;
        if (time === 0) {
          this.dialogVisible = false;
          clearInterval(this.interv);
        }
      }, 1000);
    },
    handleClose(done) {
      clearInterval(this.interv);
      done();
    },
  },
};
</script>

<style lang="less" scoped>
.el-dialog__wrapper {
  position: absolute;
  left: 208px;
  top: -36px;
  overflow: visible;
}
/deep/ .see_price {
  background: #f2f2f2;
  line-height: 1;
  width: 260px !important;
  margin: 0 !important;
  box-sizing: border-box;
  border-radius: 0;
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 2px;
      right: 4px;
    }
  }
  .el-dialog__body {
    padding: 0;
    color: #333333;
    border: 2px solid #cccccc;
    .form {
      padding: 25px 15px 15px;
      .tips {
        line-height: 20px;
      }
      .el-input {
        margin-top: 10px;
        .el-input__inner {
          line-height: 34px;
          height: 34px;
        }
        .el-input__icon {
          line-height: 34px;
        }
      }
      .el-button {
        margin-top: 10px;
        padding: 0;
        line-height: 34px;
        width: 100%;
        height: 34px;
      }
    }
    .table {
      line-height: 40px;
      padding: 10px 0 20px;
      li {
        border-bottom: 1px solid rgba(215, 215, 215, 0.4);
        padding-left: 24px;
        .price {
          font-weight: bold;
        }
      }
    }
  }
}
</style>